export default __webpack_public_path__ + "static/media/Namrata_video.03c51d91.mp4";